<template>
  <v-container fluid :class="{ 'mt-4': !$vuetify.breakpoint.mobile }">
    <mobile-data-list
      v-if="$vuetify.breakpoint.mobile"
      :items="itemData.rows || []"
      :loading="loading"
      :items-per-page="100"
      :footer-props="footerProps"
      item-key="nb1id"
      :headers="mobileHeaders"
      single-expand
    >
      <template #expanded-actions="{ item }">
        <div class="d-flex mt-2 mb-1" style="gap: 8px">
          <v-btn small outlined @click.stop="openRows(item)">
            <v-icon left small>mdi-format-list-bulleted</v-icon>
            {{ $t('uploads.viewRows') }}
          </v-btn>
          <v-btn small outlined @click.stop="doDownload(item)">
            <v-icon left small>mdi-tray-arrow-down</v-icon>
            {{ $t('uploads.download') }}
          </v-btn>
        </div>
      </template>
    </mobile-data-list>

    <v-row v-else>
      <v-col cols="12">
        <data-table-scroll-hint>
        <v-data-table
          :headers="headers"
          :items="itemData.rows"
          item-key="nb1id"
          :page.sync="currentPage"
          :items-per-page.sync="itemsPerPage"
          :footer-props="footerProps"
          class="uploaded-files-table"
          @click:row="openRows"
          :loading="loading"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon @click.stop="doDownload(item)">
              <v-icon>mdi-tray-arrow-down</v-icon>
            </v-btn>
          </template>

        </v-data-table>
        </data-table-scroll-hint>
      </v-col>
    </v-row>

    <v-dialog v-model="rowsListVisible" width="90%" scrollable>
      <UploadedFile :nb1id="currentFileId" :file="currentFileName" @close="rowsListVisible=false"></UploadedFile>
    </v-dialog>


  </v-container>
</template>

<script>
// import downloadFile from "@/utils/downloadFile";
import UploadedFile from '@/components/rights/UploadedFile.vue'
import MobileDataList from "@/components/common/MobileDataList";
import DataTableScrollHint from '@/components/common/DataTableScrollHint.vue';
import downloadFile from "@/utils/downloadFile";

export default {
  name: "UploadedFiles",
  components: {UploadedFile, MobileDataList, DataTableScrollHint},
  data() {
    return {
      loading: true,
      currentPage: 1,
      itemsPerPage: 100,
      filterBy: 0,
      itemData: [],
      rowsListVisible: false,
      currentFileId: null,
      currentFileName: null
    }
  },

  computed: {
    footerProps() {
      return { itemsPerPageOptions: this.$vuetify.breakpoint.mobile ? [] : [50, 100, 200, 500, 2000, 5000] }
    },
    mobileHeaders() {
      const h = (value) => ({ value, text: this.$t(`uploads.columns.${value}`) });
      return [
        { ...h('file'),    mobile: 'primary' },
        { ...h('nb1tid1'), mobile: 'secondary' },
        { ...h('nb1stat'), mobile: 'tertiary' },
        h('nb1tid2'),
        h('nb1tid3'),
        h('summary'),
        h('revoke'),
        h('commit'),
      ];
    },

    headers() {
      const getCol = (value) => ({
        value, 
        text: this.$t(`uploads.columns.${value}`), 
        sortable: !['actions','revoke','commit'].includes(value)}
      );
      return [
        'nb1stat',
        'nb1tid1',
        'nb1tid2',
        'nb1tid3',
        'file',
        'summary',
        'revoke',
        'commit',
        'actions'
      ].map(getCol)
    
    }
  },
  watch: {
  },

  mounted() {
    this.reloadItems()
  },

  methods: {
    openRows(item) {
      this.rowsListVisible = true;
      this.currentFileId = item.nb1id;
      this.currentFileName = item.file;
    },

    reloadItems() {
      this.loading = true
      this.$store.dispatch('app/getStagingFiles')
        .then((res) => {
          this.itemData = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },

    doDownload(item) {
      this.currentFileId = item.nb1id;
      this.currentFileName = item.file;

      this.$store.dispatch('app/getStagingFileDownloadUrl', {nb1id: item.nb1id, format: 'xlsx'})
        .then((res) => {
          downloadFile((res.filename ? res.filename : 'claims.xlsx'), res.url);
        })
    },
  },
}
</script>